'use strict';

var styleInject_es = require('../../../../node_modules/style-inject/dist/style-inject.es.js');

var css_248z = ".varta-rich-text-content {\n  margin-bottom: 20px;\n  padding: 1px 0; }\n  @media (min-width: 768px) {\n    .varta-rich-text-content {\n      margin-bottom: 35px; } }\n  @media (min-width: 1024px) {\n    .varta-rich-text-content {\n      margin-bottom: 65px; } }\n  @media (min-width: 1440px) {\n    .varta-rich-text-content {\n      margin-bottom: 100px; } }\n  .varta-rich-text-content__button {\n    margin-top: 2em; }\n";
styleInject_es(css_248z);
